// Shared DPA + HR-Safety-Contact consent surface (DESIGN §6.6 / §3.3.4).
//
// This is the legally load-bearing acceptance UI. It is rendered in TWO places
// that must stay byte-for-byte consistent in wording + behaviour:
//   • public self-serve signup ([`SignUp.tsx`](../routes/SignUp.tsx)) — sources
//     the DPA copy from the placeholder constants;
//   • admin-provisioned gated first-sign-in onboarding
//     ([`Verify.tsx`](../routes/Verify.tsx)) — sources the live DPA from
//     `GET /api/organizations/dpa`.
// Both pass their own DPA copy + checkbox state; the markup, labels, and version
// formatting live here once so a compliance-driven copy change can't land on one
// path and miss the other.

import { HR_SAFETY_CONTACT_ACKNOWLEDGEMENT_TEXT } from '@besideu/shared/signup';

export function DpaAndSafetyAcceptance({
  dpaSource,
  dpaVersion,
  dpaBody,
  dpaAccepted,
  onDpaAcceptedChange,
  safetyAck,
  onSafetyAckChange,
  required = false,
}: {
  /** `constant` renders a "placeholder" label; `db` is the CGC-approved row. */
  dpaSource: 'db' | 'constant';
  dpaVersion: string;
  dpaBody: string;
  dpaAccepted: boolean;
  onDpaAcceptedChange: (next: boolean) => void;
  safetyAck: boolean;
  onSafetyAckChange: (next: boolean) => void;
  /** Set inside a native <form> so the browser blocks submit until ticked. */
  required?: boolean;
}) {
  const dpaLabel = dpaSource === 'constant' ? `placeholder — v${dpaVersion}` : `v${dpaVersion}`;
  return (
    <>
      <section className="rounded-lg border border-border bg-muted/30 p-4 text-sm">
        <p className="font-medium">Data Processing Agreement ({dpaLabel})</p>
        <p className="mt-2 text-xs text-muted-foreground">{dpaBody}</p>
        <label className="mt-3 flex items-start gap-2">
          <input
            type="checkbox"
            className="mt-1"
            checked={dpaAccepted}
            onChange={(e) => onDpaAcceptedChange(e.target.checked)}
            required={required}
          />
          <span>I accept the Data Processing Agreement on behalf of my organisation.</span>
        </label>
      </section>

      <section className="rounded-lg border border-border bg-muted/30 p-4 text-sm">
        <p className="font-medium">HR Safety Contact acknowledgement</p>
        <p className="mt-2 text-xs text-muted-foreground">
          {HR_SAFETY_CONTACT_ACKNOWLEDGEMENT_TEXT}
        </p>
        <label className="mt-3 flex items-start gap-2">
          <input
            type="checkbox"
            className="mt-1"
            checked={safetyAck}
            onChange={(e) => onSafetyAckChange(e.target.checked)}
            required={required}
          />
          <span>I understand and accept the HR Safety Contact responsibility.</span>
        </label>
      </section>
    </>
  );
}
